<!--
  Apps (bento) menu — matches gigsumo_unified(48).html lines 1331–1395.
  Wraps the reusable <gs-dropdown> shell; panel body is a header
  (title + UI-only search), a 6-column app grid, and a footer strip.
-->
<gs-dropdown #dd class="gs-theme" align="right" [width]="panelWidth" (openChange)="onToggleChange($event)">

  <!-- Trigger: icon + "Apps" label, styled to match the other navbar items. -->
  <button gs-dd-trigger type="button"
          class="am-trigger headertext"
          title="Apps">
    <ng-icon name="tablerLayoutGrid" class="am-trigger-icon"></ng-icon>
    <span class="am-trigger-label">Apps</span>
  </button>

  <!-- Panel body -->
  <div gs-dd-panel class="am-panel">

    <!-- ── Header: title + search (UI-only filter) ── -->
    <div class="am-header">
      <span class="am-title">{{ title }}</span>
      <div class="gs-dd-search-wrap am-search-wrap">
        <ng-icon name="tablerSearch" class="gs-dd-search-icon"></ng-icon>
        <input #searchInput
               type="text"
               class="gs-dd-search am-search"
               [(ngModel)]="query"
               placeholder="Search apps..."
               aria-label="Search apps"
               autocomplete="off" />
      </div>
    </div>

    <!-- ── Grid of apps (filtered) ── -->
    <div class="am-scroll">
      <div class="am-grid" [style.--am-cols]="gridCols" *ngIf="filteredApps.length > 0; else emptyTpl">
        <button type="button"
                class="am-app"
                *ngFor="let a of filteredApps"
                [class.active-app]="a.id === activeAppId"
                (click)="onItemClick(a)">
          <span class="am-app-icon">
            <gs-dash-icon [name]="iconFor(a)"></gs-dash-icon>
          </span>
          <span class="am-app-name">{{ a.label }}</span>
        </button>
      </div>

      <ng-template #emptyTpl>
        <div class="am-empty">
          No apps match "<strong>{{ query }}</strong>"
        </div>
      </ng-template>
    </div>

    <!-- ── Footer strip ── -->
    <div class="am-footer">
      <span class="am-footer-text">
        {{ visibleApps.length }} {{ visibleApps.length === 1 ? 'app' : 'apps' }} available on your plan
      </span>
      <button type="button" class="am-footer-link" (click)="onManageClick()">
        {{ manageLabel }}
      </button>
    </div>

  </div>
</gs-dropdown>
